import React from "react";
import PropTypes from 'prop-types';

const Select = ({
  title,
  value,
  setValue,
  className = '',
  options,
  disable = false,
  required = false
}) => (
  <div className={className}>
    <label>{title} {required && <span style={{ color: 'red' }}>*</span>}</label>
    <select
      className="form-select"
      value={value}
      onChange={e => setValue(e.target.value)}
      disabled={disable}
    >
      {options.map(a => (
        <option key={a.id} value={a.id}>{a.nombre}</option>
      ))}
    </select>
  </div>
);

Select.propTypes = {
  title: PropTypes.string.isRequired,

  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]),

  setValue: PropTypes.func.isRequired,

  className: PropTypes.string,

  options: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      nombre: PropTypes.string.isRequired
    })
  ).isRequired,

  disable: PropTypes.bool,
  required: PropTypes.bool
};

export default Select;